
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/issues/[id]",
      function () {
        return require("private-next-pages/issues/[id].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/issues/[id]"])
      });
    }
  